<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="main-box">
			<div class="label">{{$t("setting.fill_bank_tip")}}</div>
			<van-cell-group>
				<van-field
					v-model="bank"
					:label="$t('setting.band_name')"
					:placeholder="$t('setting.band_name_tip')"
					input-align="right"
				/>
				<van-field
					v-model="bankid"
					:label="$t('setting.band_account')"
					:placeholder="$t('setting.band_account_tip')"
					input-align="right"
				/>
				<van-field
					v-model="username"
					:label="$t('setting.username')"
					:placeholder="$t('setting.username_place')"
					input-align="right"
				/>
			</van-cell-group>
			<p>{{$t("setting.bank_warn")}}</p>
		</div>
		<van-button class="bindCard" type="default" @click="bindCard()">{{$t("setting.bank_ok")}}</van-button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfo: {},
				bankid: "",
				username: "",
				bank: "",
				bankfenhang: "",
				fhnumber: ""
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			bindCard() {
				if (this.userInfo.bankid) {
					this.$toast(this.$t("setting.band_account_tip"));
					return true;
				}
				if (!this.bank) {
					this.$toast.fail(this.$t("setting.band_name_tip"));
					return false;
				}
				if (!this.bankid) {
					this.$toast.fail(this.$t("setting.band_account_tip"));
					return false;
				}
				if (!this.username) {
					this.$toast(this.$t("setting.username_place"));
					return false;
				}

				this.$http({
					method: 'post',
					data: {
						bankid: this.bankid,
						bank: this.bank,
						username: this.username,
						bankfenhang: this.bankfenhang,
						fhnumber: this.fhnumber
					},
					url: 'user_set_bank'
				}).then(res => {
					if (res.code === 200) {
						this.$toast(res.msg);
						this.$router.push({ path: '/Mine' });
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data || {};
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({ path: '/Login' });
			} else {
				this.getUserInfo();
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.main-box {
		background: #fff;
	}

	.main-box .label {
		padding: 20px;
		font-size: 35px;
		color: #797878;
	}

	.main-box ::v-deep .van-cell {
		font-size: 32px;
		min-height: 100px;
		align-items: center;
		line-height: normal;
		padding-top: 24px;
		padding-bottom: 24px;
	}

	.main-box ::v-deep .van-field__label {
		width: 220px;
		flex: none;
		margin-right: 16px;
		color: #323233;
		white-space: normal;
		word-break: keep-all;
		line-height: 1.35;
	}

	.main-box ::v-deep .van-field__control {
		text-align: right;
		color: #323233;
	}

	.main-box ::v-deep .van-field__control::placeholder {
		color: #c8c9cc;
		opacity: 1;
	}

	.main-box ::v-deep .van-field__control::-webkit-input-placeholder {
		color: #c8c9cc;
		-webkit-text-fill-color: #c8c9cc;
	}

	.main-box ::v-deep .van-field__control::-moz-placeholder {
		color: #c8c9cc;
		opacity: 1;
	}

	.main-box p {
		padding: 0 20px;
		font-size: 30px;
		color: #ee0a24;
	}

	.van-hairline--bottom::after {
		border-bottom-width: 3px;
	}

	.bindCard {
		margin: 20px 30px 0;
		height: 80px;
		line-height: 80px;
		border-radius: 50px;
		color: #fff;
		font-size: 30px;
		font-weight: bolder;
		border: none;
		background: linear-gradient(90deg, #e6c3a1, #7e5678);
	}
</style>
